import { render, staticRenderFns } from "./DeviceAlerts.vue?vue&type=template&id=c6bac9de"
import script from "./DeviceAlerts.vue?vue&type=script&lang=js"
export * from "./DeviceAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports